import React from 'react';
import { withFirebase } from 'components/Firebase/index.js';
import { compose } from 'recompose';
import { Button, Title } from '@bambuser-ui';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import { trackingService } from 'services/tracking/TrackingService.js';

const ExpiredAccess = ({ firebase }) => {
  const { labels } = useLocalization(getLabels);

  trackingService.track({
    eventType: 'no-org-access:visible',
  });

  const handleSignOut = () => {
    trackingService.track({
      eventType: 'no-org-access:sign-out:clicked',
    });
    firebase.doSignOut();
  };

  return (
    <div style={styles.container}>
      <Title type="h1" style={styles.header}>
        {labels.noAccessTitle}
      </Title>
      <Title type="h2" style={styles.subheader}>
        {labels.noAccessSubtitle}
      </Title>
      <Button type="primary" onClick={() => handleSignOut()}>
        {labels.signOutButtonLabel}
      </Button>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    maxWidth: 400,
  },
  header: {
    marginBottom: '20px',
  },
  subheader: {
    marginBottom: '40px',
  },
};

const getLabels = (getText) => ({
  noAccessTitle: getText('noOrgAccess.noAccessTitle'),
  noAccessSubtitle: getText('noOrgAccess.noAccessSubtitle'),
  signOutButtonLabel: getText('noOrgAccess.signOutButtonLabel'),
});

export default compose(withFirebase)(ExpiredAccess);
